<template>
  <div>
    <HomeLayout bg_icon="fyiio" v-if="$mq === 'md'">
      <h2>we've moved to a new and improved platform!</h2>
      <div class="redirect-message">
        <p>
          Hey there! We've been busy making fyiio even better. To sign up for an
          account, head over to
          <a href="https://fyi.io" target="_blank">fyi.io</a>.
        </p>
        <p class="cheeky-message">
          Don't worry, it's the same great tutorials with a fresh new look. We
          think you'll love it.
        </p>
        <a href="https://fyi.io" target="_blank" class="btn trial-btn" style="background-color:#00B8D4;color:black;font-weight:600;letter-spacing:0.5px;"
          >TAKE ME TO THE NEW PLATFORM</a
        >
      </div>
    </HomeLayout>
    <MobileLayout v-if="$mq === 'sm'">
      <h1 class="intro white-text">
        we've moved to a<br />
        new platform!
      </h1>

      <div class="redirect-card card">
        <p>
          Hey there! We've been busy making fyiio even better. To sign up for an
          account, head over to
          <a href="https://fyi.io" target="_blank">fyi.io</a>.
        </p>
        <p class="cheeky-message">
          Don't worry, it's the same great tutorials with a fresh new look. We
          think you'll love it.
        </p>
        <a href="https://fyi.io" target="_blank" class="btn" style="background-color:#00B8D4;color:black;font-weight:600;letter-spacing:0.5px;"
          >TAKE ME TO THE NEW PLATFORM</a
        >
      </div>
    </MobileLayout>
  </div>
</template>

<script>
import MobileLayout from "@/containers/layouts/MobileLayout";
import HomeLayout from "@/containers/layouts/HomeLayout";

export default {
  components: {
    MobileLayout,
    HomeLayout,
  },
};
</script>

<style scoped>
.mobileLayout {
  background-image: url("./../../assets/pond.png");
  background-size: cover;
}
.mobileLayout h1.intro {
  text-align: center;
  font-size: 32px;
  line-height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
}
p {
  font-size: 14px;
  margin-bottom: 15px;
}
.cheeky-message {
  font-style: italic;
  color: #666;
}
.redirect-message {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}
.redirect-card {
  padding: 20px;
  text-align: center;
}
.mobileLayout .btn {
  margin-top: 20px;
  width: 100%;
  color: white !important;
}
.homeLayout .trial-btn {
  min-width: 250px;
  margin: 20px auto;
  display: block;
}
a {
  color: #27aae1;
  text-decoration: underline;
}
.btn {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/Signup.vue